import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-4 border-brand-emerald bg-brand-petrol pb-16" data-id="element-75" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-76" data-mp="32o4b2ak1486j">
        <p className="text-xs leading-snug text-brand-mint" data-id="element-77" data-mp="32lrm3dfusxjz">
          © 2026 — Todos los derechos reservados.
        </p>
        <p className="mt-1 text-xs leading-snug text-brand-ivory/70" data-id="element-78" data-mp="3uf0md6qfy4rp">
          {PRODUCT_NAME} es material de apoyo académico. No sustituye formación
          profesional, práctica supervisada, bibliografía oficial, indicaciones
          clínicas ni protocolos institucionales. No habilita para indicar,
          modificar o administrar tratamientos de manera independiente.
        </p>
        <p className="mt-1.5 text-xs text-brand-ivory" data-id="element-79" data-mp="29z6tk9nn6feu">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-80" data-mp="2a19sxkaopkw8">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-brand-ivory" data-id="element-81" data-mp="3gapcti26iifg">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-mint" data-id="element-82" data-mp="3v5dgqrrxl8sy">
            Términos y condiciones
          </a>
          <span className="text-brand-mint/60" data-id="element-83" data-mp="80xiy5oewvi1">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-mint" data-id="element-84" data-mp="32w27regl89q">
            Política de privacidad
          </a>
          <span className="text-brand-mint/60" data-id="element-85" data-mp="ctgyh86nu0ph">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-mint" data-id="element-86" data-mp="cw33p162w44j">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}